import { connect } from 'react-redux'
//import { state_update } from '../actions'
//import LeftPanel from './LeftPanel'
import MainBodyPortrait from './MainBodyPortrait';
import { state_start_over,state_update } from '../actions'
import {decodeHtml} from '../reducers/utils'
import ReactGA from 'react-ga';
import smoothscroll from 'smoothscroll-polyfill';
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

const mapStateToProps = (state, ownProps) => ({
  //title:state['initial']===''?(decodeHtml(state['title']) === ''? 'Design Your Own Fashion Jewelry': decodeHtml(state['title'])):'Design Your Own Fashion Jewelry', //decodeHtml(state['title']),
  title:state['initial']===''?(decodeHtml(state['title']) === ''? 'Select To Start Customizing': decodeHtml(state['title'])):'Select To Start Customizing', //decodeHtml(state['title']),
  cfg:state['cfg1'],
  showSticky:state['showSticky'] ? false: true,
  imageSize:ownProps.imageSize,
  optionSize:ownProps.optionSize,
  orientation:ownProps.orientation,
  sh: state['sh'],
  type: state['type'],
  sku: state['sku'],
  isku: state['initialSku']
})
  
 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onStartOver: ( () =>{
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    ReactGA.event({
      category: 'StartOver',
      action:'StartOver' 
    });
    dispatch(state_start_over())}),
  onPushOpenBox: ( () =>{
    ReactGA.event({
      category: 'Zoom',
      action:'Zoom' 
    });
    dispatch(state_update({attr:'pushOpenBox',value:true}))})
  //onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value})))
//  onClick: ( () => dispatch(state_update({attr:'review',value:false})))
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainBodyPortrait)


// WEBPACK FOOTER //
// ./src/layout/MainBodyPortraitWrap.js